import { capitalizeFirst } from 'utils/string';
import { PRODUCTION_TYPES_CUSTOM_LABELS } from 'components/Production/constants/types';

export default function getProductionName(type, seasonOrSpecificName) {
  if (
    type === 'season' &&
    seasonOrSpecificName &&
    !seasonOrSpecificName.includes('season')
  ) {
    return `Season ${seasonOrSpecificName}`;
  }

  return capitalizeFirst(
    seasonOrSpecificName || PRODUCTION_TYPES_CUSTOM_LABELS[type] || type,
  );
}
